import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { WaitlistWithFilters } from "@/app/Waitlists/Components/WaitlistWithFilters";
import { UserWaitlistScreen } from "@/app/Waitlists/Screens/UserWaitlistScreen";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";

export function WaitlistsScreen() {
  return (
    <FullPageScreen>
      <Tabs defaultValue="users" className="w-full">
        <TabsList>
          <TabsTrigger value="users">All users</TabsTrigger>
          <TabsTrigger value="waitlists">All waitlists</TabsTrigger>
        </TabsList>
        <TabsContent value="users">
          <UserWaitlistScreen />
        </TabsContent>
        <TabsContent value="waitlists">
          <WaitlistWithFilters />
        </TabsContent>
      </Tabs>
    </FullPageScreen>
  );
}
